import { Checkbox } from '@gov-design-system-ce/react-form';
import type { KosPolozkaKosDto } from '@gov-nx/api';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import {
	useDaysTillDelete,
	useMojeSouborySeznamContext,
} from '@gov-nx/module/page';
import { Space } from '@gov-nx/ui/web';
import { toDateTimeReadable } from '@gov-nx/utils/common';

interface DocumentTableRowBinnedProps {
	document: KosPolozkaKosDto;
}

export const TableRowBinned = ({ document }: DocumentTableRowBinnedProps) => {
	const { controls, code, formDefinition } = useMojeSouborySeznamContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tsn = getLocalizeCurried(code);

	const {
		daysTillDeleteText,
		daysTillDeletePrefix,
		isDaysTillDeleteVisible,
		isLessThan10Days,
	} = useDaysTillDelete({
		daysTillDelete: document.dnuDoOdstraneni,
		code,
	});

	return (
		<li
			key={document.id}
			className="flex flex-col gap-(--spacing-s) relative p-(--templates-margin-l) border-b border-(--border-subtlest) [ last-of-type:border-b-0 ] [ md:mx-0 ]">
			<div className="flex flex-col gap-(--spacing-xs) [ sm:pr-(--spacing-xl) ] [ md:flex-row md:gap-(--spacing-m) md:pr-0 ]">
				{/* // @TODO: v /api/kompozitni/v1/polozkakos nechodi nazevSouboru. Rozsirit API? Nebo radeji volat /api/v1/dokumenty?smazano=true */}
				<p className="w-60 mr-auto! truncate text-body-s! text-(--text-primary-color) [ sm:w-auto sm:overflow-visible sm:whitespace-normal ]">
					<strong className="text-wrap break-all">{document.nazev}</strong>
					<span> / {tsn(`data.typ.${document.typ}`)}</span>
				</p>
				{isDaysTillDeleteVisible && (
					<div className="text-body-s text-(--text-secondary) whitespace-nowrap">
						<span className="[ md:hidden ]">{daysTillDeletePrefix}</span>
						<Space />
						<span
							className={isLessThan10Days ? 'text-(--text-status-error)' : ''}>
							{daysTillDeleteText}
						</span>
					</div>
				)}
				<div className="absolute top-(--templates-margin-l) right-(--templates-margin-l) w-(--height-m-nudge) h-(--height-m-nudge) overflow-hidden [ md:relative md:top-auto md:right-auto md:overflow-visible ]">
					<div className="frelative -mt-[10px]!">
						<Checkbox
							name={`selection.${document.id}`}
							size="m"
							isDisabled={controls.processLoading}
							hasNoLabel={true}
							aria-label={tsn('vyber.oznacit')}
							onChange={(e) => {
								formDefinition.formMethods.setValue(
									`selection.${document.id}`,
									e.target.checked
										? {
												checked: true,
												souborId: '',
											}
										: undefined
								);
							}}
							isChecked={
								formDefinition.formMethods.getValues(`selection.${document.id}`)
									?.checked
							}
						/>
					</div>
				</div>
			</div>
			<div className="whitespace-nowrap text-body-s text-(--text-secondary)">
				{tsn('data.v-kosi-od')}:{' '}
				{document.datumSmazani && toDateTimeReadable(document.datumSmazani)}
			</div>
		</li>
	);
};
